import i18next from 'i18next';
import { ecgFilterTypes, ecgResultTypes } from 'utils/ecg/ecgConstants';

export const getTranslationsForSymptoms = (symptoms, lowerCase = true) => {
    if (symptoms && symptoms.length) {
        const indexOfOther = symptoms.indexOf('OTHER');
        if (indexOfOther) {
            //move the Other symptom at the end of array
            symptoms.push(symptoms.splice(indexOfOther, 1)[0]);
        }
        const translatedSymptoms = symptoms.map((symptom) => i18next.t(`ecg:ECG_${symptom}`));
        const symptomsList = lowerCase
            ? translatedSymptoms.map((symptom, index) => (index > 0 ? symptom.toLowerCase() : symptom))
            : translatedSymptoms;
        return symptomsList.join(', ');
    }
    return '--';
};

export const getTranslationsForResultTypes = (resultTypes) => {
    if (resultTypes && resultTypes.length) {
        const translatedResultTypes = resultTypes.map((resultType) =>
            i18next.t(`ecg:ecg_rhythm_classification_${resultType}`)
        );
        return translatedResultTypes.join(', ');
    }
    return '--';
};

export const getEcgRecordingName = (rhythmClassification) => {
    return i18next.t(`ecg:ecg_recording`) + ' - ' + i18next.t(`ecg:ecg_rhythm_classification_${rhythmClassification}`);
};

export const getNumberOfSymptoms = (symptoms = []) => {
    if (symptoms.length > 1) {
        return symptoms.length;
    }

    if (symptoms.length === 1) {
        if (symptoms[0] === 'NO_SYMPTOMS') {
            return 0;
        }
        return 1;
    }

    return 0;
};

export const getUpdatedFilters = (activeFilters, filterType, filterValue) => {
    const newFilters = {
        symptoms: activeFilters && activeFilters.symptoms ? [...activeFilters.symptoms] : [],
        resultTypes: activeFilters && activeFilters.resultTypes ? [...activeFilters.resultTypes] : [],
        dates: activeFilters && activeFilters.dates ? { ...activeFilters.dates } : { fromDate: '', toDate: '' }
    };

    let filterIndex = -1;
    switch (filterType) {
        case ecgFilterTypes.SYMPTOMS.type:
            filterIndex = newFilters.symptoms.indexOf(filterValue);

            // add symptom to the list
            if (filterIndex === -1) {
                newFilters.symptoms.push(filterValue);
            } else {
                // remove symptom from the list
                newFilters.symptoms.splice(filterIndex, 1);
            }
            break;
        case ecgFilterTypes.RESULT.type:
            filterIndex = newFilters.resultTypes.indexOf(filterValue);

            // add result type to the list
            if (filterIndex === -1) {
                newFilters.resultTypes.push(filterValue);
            } else {
                // remove result type from the list
                newFilters.resultTypes.splice(filterIndex, 1);
            }
            break;
        case ecgFilterTypes.DATE.type:
            const { fromDate, toDate } = filterValue;
            newFilters.dates = { fromDate, toDate };
            break;
        default:
            break;
    }

    return newFilters;
};

export const getResultTypesForQueryParams = (resultTypesKeys) => {
    let resultTypes = [];

    resultTypesKeys.forEach((resultKey) => {
        resultTypes = resultTypes.concat(ecgResultTypes[resultKey]);
    });

    return resultTypes;
};

export const showEcgInBackbone = (ecgRolePreference, ecgEnabled, usageIndicators) => {
    return (
        ecgRolePreference.featureEnabled() && // feature flag
        ecgEnabled &&
        ecgEnabled.getValue() === 'true' &&
        usageIndicators.hasCurrentOrHistoricalIndicator('device', 'hasEcgCapableDevice')
    );
};
